import { useParams } from 'react-router-dom';
import { SettingsScreen } from '@/settings/SettingsLayout';
import { PeoplePanel } from '@/team/PeoplePanel';
import { RolesPanel } from '@/team/RolesPanel';
import { HoursPanel } from '@/team/HoursPanel';
import { RoutingPanel } from '@/team/RoutingPanel';
import { DeveloperPanel } from '@/team/DeveloperPanel';
import { PlanPanel } from '@/team/PlanPanel';
import { QuickRepliesPanel } from '@/team/QuickRepliesPanel';
import { NumbersPanel } from '@/team/NumbersPanel';
import { TargetsPanel } from '@/team/TargetsPanel';
import { CataloguePanel } from '@/team/CataloguePanel';
import { NotificationsPanel } from '@/team/NotificationsPanel';

/**
 * `/settings/:section` → the section's screen inside the settings frame.
 *
 * A switch rather than five routes so the registry in `sections.tsx` stays the
 * single list: a key that is in the column and not here renders the frame with
 * nothing in it, which is visible on the first click rather than a 404 nobody
 * reports.
 */
export function SettingsSectionRoute() {
  const { section = '' } = useParams();

  return (
    <SettingsScreen section={section}>
      {section === 'people' && <PeoplePanel />}
      {section === 'roles' && <RolesPanel />}
      {section === 'hours' && <HoursPanel />}
      {section === 'notifications' && <NotificationsPanel />}
      {section === 'routing' && <RoutingPanel />}
      {section === 'numbers' && <NumbersPanel />}
      {section === 'targets' && <TargetsPanel />}
      {section === 'quick-replies' && <QuickRepliesPanel />}
      {section === 'catalogue' && <CataloguePanel />}
      {section === 'developer' && <DeveloperPanel />}
      {section === 'plan' && <PlanPanel />}
    </SettingsScreen>
  );
}
